import { render, staticRenderFns } from "./AccountSettingsCompany.vue?vue&type=template&id=1f608391&scoped=true&"
import script from "./AccountSettingsCompany.vue?vue&type=script&lang=js&"
export * from "./AccountSettingsCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f608391",
  null
  
)

export default component.exports